<template>
  <div
    :style="{ gridColumn: span ? `span ${span} / auto` : null }"
    class="grid-item"
  >
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'CGridItem',

  props: {
    span: {
      type: Number
    }
  }
}
</script>
